import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n *\n */\n/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n * \n */\n.vai-table__row {\n  height: var(--vai-table-row-height);\n  vertical-align: middle;\n  background-color: var(--vai-color-white);\n  background-clip: padding-box;\n}\n\n.vai-theme-dark .vai-table__row {\n  background-color: var(--vai-color-black-light);\n}";
styleInject(css_248z);

export { css_248z as default };
